import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "./component/LoginPage/loginPage";
import MyProfile from "./component/Pages/MyProfile/MyProfile";
import ChangePassword from "./component/Pages/ChangePassword/ChangePassword";
import AddQuestionMain from "./component/Pages/Exam/AddQuestion/AddQuestionMain";
import AddCenterFeedBackQuestion from "./component/Pages/Exam/CenterFeedBack/AddCenterFeedBackQuestion";
import ExamResult from "./component/Pages/Exam/ExamResult/ExamResult";
import OtpScreen from "./component/LoginPage/otpScreen";
import SettingsMain from "./component/Pages/Settings/SettingsMain";
import BasicSixMonths from "./Routes/BasicSixMonths";
import Dashboard from "./component/Pages/Dashboard/DashboardView/Dashboard";
import ExamScore from "./component/Pages/Exam/ExamResult/ExamScore";
import ExamScoreFeedBack from "./component/Pages/Feedback/ExamFeedbackResult/ExamScore";
import Qpsync from "./component/Pages/QpSync/Qpsync";

const HomePageRoutes = ({
  planName,
  isLoggedIn,
  fetchDataFromAPI,
  handleLogin,
  header,
  globalProfileImageState
}) => (
  <Routes>
    {(() => {
      let routesToRender;
      switch (planName) {
        default:
          routesToRender = BasicSixMonths;
          break;
      }
      return routesToRender.map((data, index) => (
        <Route
          path={data?.path}
          element={
            isLoggedIn && data?.path === "/admin/dashboard" ? (
              <Dashboard header={header} globalProfileImageState={globalProfileImageState} />
            ) : (
              isLoggedIn && data?.element
            )
          }
          key={index}
        />
      ));
    })()}
    <Route
      path="/admin/addquestion/:rowId"
      element={isLoggedIn && <AddQuestionMain />}
    />
    <Route
      path="/admin/addcenterfeedbackquestion/:rowId"
      element={isLoggedIn && <AddCenterFeedBackQuestion />}
    />
    <Route
      path="/admin/qpsync/:rowId"
      element={isLoggedIn && <Qpsync />}
    />
    <Route
      path="/admin/examresult/:rowId"
      element={isLoggedIn && <ExamResult />}
    />
    <Route
      path="/admin/examresult/:rowId/examscore"
      element={isLoggedIn ? <ExamScore /> : <Navigate to="/" />}
    />
    <Route
      path="/admin/examfeedbackresult/:rowId/examscore"
      element={isLoggedIn ? <ExamScoreFeedBack /> : <Navigate to="/" />}
    />

    <Route
      path="/admin/myprofile"
      element={isLoggedIn && <MyProfile fetchDataFromAPI={fetchDataFromAPI} />}
    />

    <Route
      path="/admin/settings"
      element={
        isLoggedIn && <SettingsMain fetchDataFromAPI={fetchDataFromAPI} />
      }
    />
    <Route
      path="/admin/changepassword"
      element={isLoggedIn && <ChangePassword />}
    />
    {/* <Route
      path="/:coachingname/:formId"
      element={formFound ? <FormSubmission /> : <LoginPage />}
    /> */}
{/* 
    <Route
      path="/:dynamicPath"
      element={(() => {
        if (layoutData) {
          switch (layoutData.layout.layouttype) {
            case "layout1":
              return <Layout1 />;
            case "layout2":
              return <Layout2 />;
            case "layout3":
              return <Layout3 />;
            case "layout4":
              return <Layout4 />;
            case "layout5":
              return <Layout5 />;
            default:
              return null;
          }
        }
        return null;
      })()}
    /> */}

    <Route
      path="/"
      element={
        isLoggedIn ? (
          <Navigate to="/admin/dashboard" />
        ) : (
          <LoginPage onLogin={handleLogin} />
        )
      }
    />
    <Route
      path="/otpscreen/:a"
      element={
        isLoggedIn ? (
          <Navigate to="/admin/dashboard" />
        ) : (
          <OtpScreen onLogin={handleLogin} />
        )
      }
    />
    <Route path="*" element={<Navigate to="/" />} />
  </Routes>
);

export default HomePageRoutes;
